var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddUser = function SvgAddUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 16.5V11.5M13.3333 14H18.3333M9.99996 11.5H6.66663C5.11349 11.5 4.33692 11.5 3.72435 11.7537C2.90759 12.092 2.25867 12.741 1.92036 13.5577C1.66663 14.1703 1.66663 14.9469 1.66663 16.5M12.9166 1.7423C14.1382 2.23679 15 3.43443 15 4.83333C15 6.23224 14.1382 7.42988 12.9166 7.92437M11.25 4.83333C11.25 6.67428 9.75758 8.16667 7.91663 8.16667C6.07568 8.16667 4.58329 6.67428 4.58329 4.83333C4.58329 2.99238 6.07568 1.5 7.91663 1.5C9.75758 1.5 11.25 2.99238 11.25 4.83333Z",
    stroke: "#000957",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "add-user.106c33088941b9b32bb5ccc1bb498aa5.svg";